var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7324 3.36626C14.5714 1.34926 17.4286 1.34927 18.2676 3.36626L21.097 10.1689C21.1475 10.2904 21.2617 10.3734 21.3929 10.3839L28.7369 10.9727C30.9144 11.1473 31.7974 13.8647 30.1383 15.2858L24.5429 20.0789C24.443 20.1645 24.3994 20.2988 24.4299 20.4267L26.1394 27.5933C26.6463 29.7182 24.3347 31.3977 22.4704 30.259L16.1829 26.4186C16.0706 26.35 15.9294 26.35 15.8171 26.4186L9.52959 30.259C7.66533 31.3977 5.35374 29.7182 5.8606 27.5933L7.57008 20.4267C7.60061 20.2988 7.55698 20.1645 7.45706 20.0789L1.86167 15.2858C0.202627 13.8647 1.08559 11.1473 3.2631 10.9727L10.6072 10.3839C10.7383 10.3734 10.8525 10.2904 10.9031 10.1689L13.7324 3.36626ZM16.3239 4.17466C16.2041 3.88652 15.7959 3.88652 15.6761 4.17466L12.8467 10.9773C12.493 11.8276 11.6934 12.4086 10.7754 12.4822L3.43132 13.071C3.12024 13.0959 2.99411 13.4841 3.23111 13.6872L8.82651 18.4802C9.52591 19.0793 9.83136 20.0194 9.61767 20.9152L7.90819 28.0817C7.83578 28.3853 8.16601 28.6252 8.43233 28.4625L14.7199 24.6221C15.5058 24.1421 16.4942 24.1421 17.2801 24.6221L23.5677 28.4625C23.834 28.6252 24.1642 28.3853 24.0918 28.0817L22.3823 20.9152C22.1686 20.0194 22.4741 19.0793 23.1735 18.4802L28.7689 13.6872C29.0059 13.4841 28.8798 13.0959 28.5687 13.071L21.2246 12.4822C20.3067 12.4086 19.507 11.8276 19.1533 10.9773L16.3239 4.17466Z",
    fill: "#1B0076",
    stroke: "#1B0076",
    strokeWidth: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineStar);
export default __webpack_public_path__ + "static/media/line-star.9f0ed6e6.svg";
export { ForwardRef as ReactComponent };